import { useEffect, useState } from 'react';
import { getCachedEurUsdRate } from '../services/currency/get_cached_eur_usd_rate';

/**
 * @description Hook to fetch the EUR/USD rate
 * @returns {Object} { rate, loading, error }
 */

export function useEurUsdRate() {
  const [rate, setRate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    (async () => {
      try {
        const data = await getCachedEurUsdRate();
        if (!isCancelled) {
          setRate(data);
        }
      } catch (err) {
        console.log("error of useEurUsdRate", err);
        if (!isCancelled) {
          setError(err);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, []);

  return { rate, loading, error };
}